import React from "react";
import { SITE, TELEGRAM_URL } from "@/config";
import { trackSubscribe } from "@/lib/track";
import { Send } from "lucide-react";

const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="footer"
            className="bg-[#0a0a0a] text-white/70"
        >
            <div className="px-6 md:px-12 lg:px-24 py-16 grid lg:grid-cols-12 gap-10">
                <div className="lg:col-span-5">
                    <div className="flex items-center gap-3">
                        <img
                            src={SITE.logoUrl}
                            alt="MZ Trading Lab"
                            data-testid="footer-logo"
                            className="h-16 w-auto object-contain"
                        />
                    </div>
                    <div className="mt-3 text-xs text-white/55">
                        Daily signals · Live sessions · Real community
                    </div>
                    <p className="mt-5 text-sm leading-relaxed max-w-md">
                        A trading lab built for beginner and struggling traders
                        in Malaysia, Singapore and beyond — where education
                        comes before hype.
                    </p>
                </div>

                <div className="lg:col-span-3">
                    <div className="font-display text-sm font-semibold text-white uppercase tracking-widest">
                        Explore
                    </div>
                    <ul className="mt-4 space-y-2.5 text-sm">
                        <li>
                            <a
                                href="#problem"
                                data-testid="footer-link-problem"
                                className="hover:text-white transition-colors"
                            >
                                The Struggle
                            </a>
                        </li>
                        <li>
                            <a
                                href="#testimonials"
                                data-testid="footer-link-solution"
                                className="hover:text-white transition-colors"
                            >
                                Reviews
                            </a>
                        </li>
                        <li>
                            <a
                                href="#benefits"
                                data-testid="footer-link-benefits"
                                className="hover:text-white transition-colors"
                            >
                                What's Inside
                            </a>
                        </li>
                        <li>
                            <a
                                href="#faq"
                                data-testid="footer-link-faq"
                                className="hover:text-white transition-colors"
                            >
                                FAQ
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="lg:col-span-4">
                    <div className="font-display text-sm font-semibold text-white uppercase tracking-widest">
                        Get Started
                    </div>
                    <p className="mt-4 text-sm text-white/60 leading-relaxed">
                        Jump into our Telegram channel and meet the community.
                    </p>
                    <a
                        href={TELEGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-cta"
                        onClick={trackSubscribe}
                        className="btn-primary mt-5 inline-flex items-center gap-2 bg-[#0077b6] hover:bg-[#005f92] text-white font-semibold rounded-xl px-5 py-3 text-sm transition-colors"
                    >
                        <Send className="h-4 w-4" />
                        Join MZ Trading Lab
                    </a>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="px-6 md:px-12 lg:px-24 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/45">
                    <p>
                        © {year} MZ Trading Lab. All rights reserved.
                    </p>
                    <p
                        data-testid="footer-disclaimer"
                        className="max-w-xl sm:text-right leading-relaxed"
                    >
                        Risk disclaimer: Trading carries significant risk and
                        may not be suitable for all investors. Past performance
                        is not indicative of future results.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
